import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  resetBasket,
  selectActiveBasketAccounts,
} from '@epicuro-next/state/basket-state';
import { resetFilters, setSubsites } from '@epicuro-next/state/p-basket-state';
import { resetProductListStore } from '@epicuro-next/state/product-list-state';
import { go } from '@epicuro-next/state/router-store';
import { selectSubSiteId } from '@epicuro-next/state/session-state';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { AccountsSelectorComponentStore } from '../../store/accounts-selector.component-store';
import { AccountSelectorBaseComponent } from '../account-selector-base/account-selector-base.component';

@Component({
  selector: 'epc-account-selector-menu',
  templateUrl: './account-selector-menu.component.html',
  styleUrls: ['./account-selector-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AccountsSelectorComponentStore],
  standalone: false,
})
export class AccountSelectorMenuComponent
  extends AccountSelectorBaseComponent
  implements OnInit
{
  @Output() public closeMenu = new EventEmitter();

  public isSelectedAccountsShown$ =
    this.componentStore.isSelectedAccountsShown$;
  public selectedAccounts$ = this.componentStore.selectedAccounts$;
  public isDeselectAllShown$ = this.componentStore.isDeselectAllShown$;

  constructor(store: Store, componentStore: AccountsSelectorComponentStore) {
    super(store, componentStore);
  }

  public ngOnInit() {
    super.ngOnInit();
    this.store
      .pipe(select(selectActiveBasketAccounts), take(1))
      .subscribe((selectedAccounts) => {
        this.componentStore.setInitialSelection(selectedAccounts);
      });
  }

  public createBtnTitle(count: number) {
    return $localize`:Accounts|Create new basket@@createNewBasket:Create new basket for ${count} shops`;
  }

  /**
   * method to reset basket state for new be created
   */
  public createBasket(): void {
    this.store.dispatch(resetBasket());
  }

  public handleCreateNewBasket(): void {
    this.createBasket();
    this.confirm();
    this.closeMenu.emit();
    this.resetFilters();
    this.store.dispatch(resetProductListStore());
    this.store.dispatch(
      go({ commands: ['/'], extras: { state: { forceLeaveBasket: true } } }),
    );
  }

  private resetFilters() {
    this.store.pipe(select(selectSubSiteId), take(1)).subscribe((subsites) => {
      this.store.dispatch(resetFilters());

      if (subsites) {
        this.store.dispatch(setSubsites({ subsites }));
      }
    });
  }
}
